import endpoints from "../utils/endpoints";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError, notificationSucces } from "./notification";

export async function getBingoGamesList(params: any){
    let res = {
      count: 0,
      page: null,
      perpage: 0,
      list: [
        {
            gameImage: "",
            gameTitle: "",
            forms: [
                {
                    form: "",
                    wager: "",
                    available: "No"
                }
            ]
        }
      ],
    };
    if(params) {
      params = removeEmpty(params)
    }
    await Api.get(endpoints.getBingoGamesList, {params}).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Error on getting bingo games')
    })
    
    return res
}

export async function updateBingoGames(payload: any, params: any) {

    await Api.post(`${endpoints.updateBingoGames}?id=${params}`, payload).then((response) => {
      if(response.status === 200) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              notificationSucces('Bingo games changed successfully')
          }
      } else {
        notificationError('Could not update bingo games')
      }
    }).catch((err: string) => {
      notificationError('Could not get data bingo games')
    })
}
